const { deleteCookie } = require('./delete-cookie')
const { getCookie } = require('./get-cookie')
const { getCookieSettings } = require('./get-cookie-settings')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} name
 * @param {string|number} value
 * @param {number|null} lifeTimeInDays
 */
function setCookie (name, value, lifeTimeInDays = null) {
  if (typeof document === 'undefined' || !name) return
  if (getCookie(name)) deleteCookie(name)

  const cookieValues = []
  const cookieSettings = getCookieSettings()

  cookieValues.push(`${name}=${value};`)

  if (lifeTimeInDays) {
    const maxAge = 90000000 * lifeTimeInDays
    cookieValues.push(`maxAge=${maxAge};`)
  } else {
    cookieValues.push(`maxAge=${cookieSettings.maxAge};`)
  }

  cookieValues.push('secure;')
  cookieValues.push('sameSite=none;')
  cookieValues.push('path=/;')

  document.cookie = cookieValues.join(' ')
}

module.exports = { setCookie }
